import * as React from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import { useTranslation } from "react-i18next";
import InfoIcon from "@mui/icons-material/Info";
import {
  Autocomplete,
  Divider,
  Grid,
  Paper,
  Stack,
  TextField,
} from "@mui/material";

import { useState , useEffect} from "react";

import * as Yup from "yup";
// form
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { responsiveValue } from "../../theme/Styles/responsiveValue";
import { FormProvider, RHFTextField } from "../hook-form";
import { LoadingButton } from "@mui/lab";

import { AddressData } from "../../common/enum/addressData";
import { useDispatch, useSelector } from "react-redux";
import {
  addUserAddress,
  getAddressStatus,
} from "../../Containers/OnBoarding/slice";
import {
  setSnackbarMessage,
  setSnackbarOpen,
  setSnackbarSeverity,
} from "../../Containers/AdminView/adminSlice";
import { getUserEntity } from "../../redux/features/authSlice";
import MapLeaflet from "../../Containers/MapLeaflet";
import { useSnackbar } from "notistack";
import { EntityType } from "../../common/enum";

export default function AddAddressFrom({
  t,
  editAddress,
  setEditAddress,
  setOpen,
  address,
  setConfirmationDialog,
  setModalOpen,
  setModelContent,
  setDeleteAddressId,
}) {
  const {
    auth: {
      profile: { entity },
    },
    onBoarding: { addressStatus, loading },
    dashboardInfo: { entityProfileSelect },
  } = useSelector((state) => state);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [showError, setShowError] = useState(null);
  const [select1, setSelect1] = useState(null);
  const [select2, setSelect2] = useState(null);
  const [select3, setSelect3] = useState(null);
  const [position, setPosition] = useState({
    lat: 38.736946,
    lng: -9.142685,
  });
  const [positionError, setPositionError] = useState(false);

  const addressSchema = Yup.object().shape({
    addressHousehold: Yup.string().required(`${t("houseHold")} é de preenchimento obrigatório`),
    postalCode1: Yup.string()
      .required(`${t("postcard")} é de preenchimento obrigatório `)
      .matches(/^[0-9]+$/, "Must be only digits")
      .min(4, "Must be exactly 4 digits")
      .max(4, "Must be exactly 4 digits"),
    postalCode2: Yup.string()
      .required(`${t("postcard")} é de preenchimento obrigatório `)
      .matches(/^[0-9]+$/, "Must be only digits")
      .min(3, "Must be exactly 3 digits")
      .max(3, "Must be exactly 3 digits"),
    locality: Yup.string().required(`${t("locality")} é de preenchimento obrigatório `),
    addressTitle: Yup.string().required(`${t("addressTitle")} é de preenchimento obrigatório `),
    phone: Yup.string()
    .required(`O campo ${t("phone")} é de preenchimento obrigatório`)
    .matches(/^(\+[\d]{1,5}|0)?[0-9]+$/, "devem ser apenas números")
    .min(9, 'O campo contato telefónico deve ter no mínimo 9 dígitos')
    .max(12, 'O campo contato telefónico deve ter no máximo 12 dígitos'),
    emailForAddress: Yup.string()
      .email("Insira um e-mail válido")
      .required(`${t("emailAddress")} é de preenchimento obrigatório`),
  });

  const defaultValues = {
    addressHousehold: editAddress ? address?.addressLine : "",
    postalCode1: editAddress ? address?.postalCode.slice(0, 4) : "",
    postalCode2: editAddress ? address?.postalCode.slice(5) : "",
    locality: editAddress ? address?.locality : "",
    addressTitle: editAddress ? address?.addressTitle : "",
    phone: editAddress ? address?.phone : "",
    emailForAddress: editAddress ? address?.email : "",
  };

  React.useEffect(() => {
    if (editAddress) {
      setSelect1(address.district);
      setSelect2(address.county);
      setSelect3(address.subDivision);
      setPosition({ lat: address?.latitude, lng: address?.longitude });
    }
  }, [editAddress]);

  const methods = useForm({
    resolver: yupResolver(addressSchema),
    defaultValues,
  });
  const {
    handleSubmit,
  } = methods;

  const setMarkerSDefaultPosition = (value) => {
    setPosition(value);
    setPositionError(false);
  };

  const onSubmit = async (data) => {
    const {
      emailForAddress,
      phone,
      addressTitle,
      addressHousehold,
      locality,
      postalCode1,
      postalCode2,
    } = data;
    if (position !== null) {
      setPositionError(false);
      const payload = {
        entityId: editAddress ? address.entityId : entity.entityId,
        addressTitle : $("#addressTitle").val(),
        addressLine: $("#addressHousehold").val(),
        district: select1,
        county: select2,
        subDivision: select3,
        postalCode: `${$("#postalCode1").val()}-${$("#postalCode2").val()}`,
        locality: $("#locality").val(),
        latitude: position?.lat,
        longitude: position?.lng,
        phone: $("#phone").val(),
        email: $("#emailForAddress").val()
      };
      if (!editAddress) {
        payload["id"] = 0;
        payload["isHeadquarter"] = false;
        payload["isExternal"] = false;
      } else {
        payload["id"] = address.id;
        payload["addressId"] = address.addressId;
        payload["isHeadquarter"] = address.isHeadquarter;
        payload["isExternal"] = address.isExternal;
        payload["updatedBy"] = address.entityId;
      }
      await dispatch(addUserAddress(payload))
        .unwrap()
        .then((res) => {
          dispatch(getUserEntity(entity.entityId));
          enqueueSnackbar({
            message: !editAddress
              ? t("successfullyAddedAddress")
              : t("successfullyUpdateAddress"),
            variant: "success",
          });
          setOpen(false);
        })
        .catch((error) => {
          enqueueSnackbar({
            message: t("someThingWentWrong"),
            variant: "error",
          });
        });
    } else {
      setPositionError(true);
    }
  };

  const onDeleteHandle = (e) => {
    dispatch(getAddressStatus(address.addressId))
      .unwrap()
      .then((res) => {
        if (res.isActive) {
          setModalOpen(true);
          setModelContent(
            entity?.entityType === EntityType.donor ||
              (entity?.entityType === EntityType.donorDistributor &&
                entityProfileSelect === EntityType.donor)
              ? t("activeDonorAddress")
              : t("activeReceiverAddress")
          );
        } else {
          setConfirmationDialog(true);
          setDeleteAddressId(address.addressId);
        }
      })
      .catch((err) => {
        console.error(err);
        enqueueSnackbar({
          message: t("someThingWentWrong"),
          variant: "error",
        });
      });
  };

const fetchCoordinates = async (address) => {
  try {
    address = address.replaceAll(".", "");
    const response = await fetch(
      `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}`
    );
    const data = await response.json();
    if (data && data.length > 0) {
      setPosition({
        lat: parseFloat(data[0].lat),
        lng: parseFloat(data[0].lon),
      });
      setPositionError(false);
    }
  } catch (err) {
    console.error("Erro ao buscar coordenadas:", err);
    setPositionError(true);
  }
};
const buildFullAddress = (data, select1, select2, select3) => {
  const parts = [
    data.addressHousehold,
    `${data.postalCode1}-${data.postalCode2}`,
    data.locality,
    select3,   // freguesia
    select2,   // concelho
    select1,   // distrito
  ];

  // Remove vazios e duplicados mantendo a ordem
  return [...new Set(parts.filter(Boolean))].join(", ");
};




useEffect(() => {
  if (editAddress) {
  const fullAddress = buildFullAddress(methods.getValues(), select1, select2, select3);
fetchCoordinates(fullAddress);
  }
}, [editAddress, select1, select2, select3]);

  return (
    <>
      <Grid
        marginTop="1px"
        container
        spacing={responsiveValue("", "", "", "2", "2", "0")}
        direction={responsiveValue("", "", "", "row", "row", "column-reverse")}
        justifyContent={"space-evenly"}
      >
        <Grid item>
          <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
            <Typography>
              {editAddress ? `${t("edit")} ${t("address")}` : t("addAddress")}
            </Typography>
            <Box>
              <Box>
                <Stack spacing={3}>
                  <Paper sx={{ padding: "10px" }}>
                    <RHFTextField
                      id="addressTitle"
                      label={t("addressTitle")+ "*"}
                      variant="outlined"
                      name="addressTitle"
                      sx={{ marginTop: "20px" }}
                      fullWidth
                      
                    />
                    <RHFTextField
                      id="addressHousehold"
                      label={t("houseHold")+ "*"}
                      variant="outlined"
                      name="addressHousehold"
                      sx={{ marginTop: "20px" }}
                      fullWidth
                       onBlur={() => {
                        const fullAddress = buildFullAddress(methods.getValues(), select1, select2, select3);
                        fetchCoordinates(fullAddress);
                    }}
                    />
                    <RHFTextField
                      id="phone"
                      label={t("phone")+ "*"}
                      variant="outlined"
                      name="phone"
                      sx={{ marginTop: "20px" }}
                      fullWidth
                      inputProps={{ maxLength: 9 }}
                    />
                    <RHFTextField
                      id="emailForAddress"
                      label={"Endereço de e-mail*"}
                      variant="outlined"
                      name="emailForAddress"
                      sx={{ marginTop: "20px" }}
                      fullWidth
                     
                    />

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        flexDirection: responsiveValue(
                          "",
                          "",
                          "",
                          "row",
                          "row",
                          "column"
                        ),
                      }}
                    >
                     <Autocomplete
                        value={select1 || address?.district || ""}
                        noOptionsText={t("noOptionsText")}
                        disablePortal
                        options={AddressData.map((item) => item.district).sort((a, b) => a.localeCompare(b, "pt-PT"))}
                        sx={{
                          width: responsiveValue("", "", "", "32%", "32%", "100%"),
                          marginTop: "20px",
                        }}
                        isOptionEqualToValue={(option, value) => option === value}
                        onBlur={() => {
                          const fullAddress = buildFullAddress(methods.getValues(), select1, select2, select3);
                          fetchCoordinates(fullAddress);
                        }}
                        onChange={(event, value) => {
                          setSelect1(value);
                          setSelect2(null);
                          setSelect3(null);
                        }}
                        renderInput={(params) => (
                          <TextField
                            helperText={!select1 && showError ? `Please Select Your ${t("district")}.` : null}
                            error={showError && !select1}
                            {...params}
                            label={t("district")+ "*"}
                          />
                        )}
                      />
                      <Autocomplete
                      noOptionsText={t('noOptionsText')}
                        disablePortal
                         defaultValue={
                          AddressData.find(item => item?.district === select1)
                            ?.county.find(item => item?.countyName === select2)
                            ?.countyName || ""
                        }
                        isOptionEqualToValue={(option, value) =>
                          option === value
                        }
                        onBlur={() => {
                          const fullAddress = buildFullAddress(methods.getValues(), select1, select2, select3);
                          fetchCoordinates(fullAddress);
                        }}
                        options={
                          select1
                            ? AddressData.find(
                                ({ district }) => district === select1
                              ).county.map((county) => county.countyName).sort((a, b) => a.localeCompare(b, 'pt-PT'))
                            : []
                        }
                        sx={{
                          width: responsiveValue(
                            "",
                            "",
                            "",
                            "32%",
                            "32%",
                            "100%"
                          ),
                          marginTop: "20px",
                        }}
                        getOptionLabel={(option) => (option ? option : "")}
                        value={select2 !== null ? select2 : ""}
                        onChange={(event, value) => setSelect2(value)}
                        renderInput={(params) => (
                          <TextField
                            helperText={
                              !select2 && showError
                                ? `Pease Select Your ${t("county")}.`
                                : null
                            }
                            error={showError && !select2}
                            {...params}
                            label={t("county")+ "*"}
                          />
                        )}
                      />

                      <Autocomplete
                      noOptionsText={t('noOptionsText')}
                        disablePortal
                        defaultValue={
                          AddressData.find(item => item?.district === select1)
                            ?.county.find(item => item?.countyName === select2)
                            ?.fregusias.find(item => item?.freguesiaName === select3)
                            ?.freguesiaName || ""
                        }
                        isOptionEqualToValue={(option, value) =>
                          option === value
                        }
                         onBlur={() => {
                        const fullAddress = buildFullAddress(methods.getValues(), select1, select2, select3);
                        fetchCoordinates(fullAddress);
                    }}
                       options={
                          select2
                            ? (
                                AddressData.find(({ district }) => district === select1)
                                  ?.county.find(({ countyName }) => countyName === select2)
                                  ?.fregusias?.map(subDivision => subDivision.freguesiaName)
                                  ?.sort((a, b) => a.localeCompare(b, "pt-PT"))
                              ) || []
                            : []
                        }
                        sx={{
                          width: responsiveValue(
                            "",
                            "",
                            "",
                            "32%",
                            "32%",
                            "100%"
                          ),
                          marginTop: "20px",
                        }}
                        value={select3 !== null ? select3 : ""}
                        onChange={(event, value) => setSelect3(value)}
                        getOptionLabel={(option) => (option ? option : "")}
                        renderInput={(params) => (
                          <TextField
                            helperText={
                              !select3 && showError
                                ? `Pease Select Your ${t("parshi")}.`
                                : null
                            }
                            error={showError && !select3}
                            {...params}
                            label={t("parshi")+ "*"}
                          />
                        )}
                      />
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        flexDirection: responsiveValue(
                          "",
                          "",
                          "",
                          "",
                          "",
                          "row"
                        ),
                      }}
                    >
                      <Box
                        sx={{
                          width: "40%",
                          display: "flex",
                          marginTop: "20px",
                          alignItems: "center",
                        }}
                      >
                        <RHFTextField
                          id="postalCode1"
                          label={t("postcard")+ "*"}
                          name="postalCode1"
                          variant="outlined"
                          sx={{ width: "50%" }}
                          inputProps={{ maxLength: 4 }}
                           onBlur={() => {
                        const fullAddress = buildFullAddress(methods.getValues(), select1, select2, select3);
                        fetchCoordinates(fullAddress);
                    }}
                          
                        />
                        <Box
                          sx={{
                            width: "17px",
                            height: "2px",
                            background: "gray",
                            marginX: "5px",
                          }}
                        >
                          {" "}
                        </Box>
                        <RHFTextField
                          id="postalCode2"
                          variant="outlined"
                          name="postalCode2"
                          sx={{ width: "50%" }}
                          label="*"
                          //className="noLabel"
                          inputProps={{ maxLength: 3 }}
                           onBlur={() => {
                        const fullAddress = buildFullAddress(methods.getValues(), select1, select2, select3);
                        fetchCoordinates(fullAddress);
                    }}
                        />
                      </Box>
                      <Box
                        sx={{
                          width: "58%",
                        }}
                      >
                        <RHFTextField
                          id="locality"
                          label={t("locality")+ "*"}
                          variant="outlined"
                          name="locality"
                          sx={{ marginTop: "20px" }}
                          fullWidth
                           onBlur={() => {
                        const fullAddress = buildFullAddress(methods.getValues(), select1, select2, select3);
                        fetchCoordinates(fullAddress);
                    }}
                        />
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        width: 1,
                        backgroundColor: "#e5f1ff",
                        display: "flex",
                        alignItems: "center",
                        borderRadius: 1.5,
                        p: 1.5,
                        my: 2,
                      }}
                    >
                      <InfoIcon sx={{ color: "#0167d6" }} />
                      <Typography variant="body2" fontWeight={500} mx={2}>
                        {`${t("mapInfo")+ "*"}`}
                      </Typography>
                    </Box>
                    <Box sx={{ width: 1, height: 400, py: 1 }}>
                      <MapLeaflet
                      isDirectionAble={false}
                      isSearchAble={true}
                      position={position}
                      setPosition={setMarkerSDefaultPosition}
                      t={t}
                      onAddressFound={(addr) => {
                              methods.setValue(
                                "addressHousehold",
                                `${addr.road || ""} ${addr.house_number || ""}`.trim()
                              );
  
                              const [pc1 = "", pc2 = ""] = (addr.postcode || "").split("-");
                              methods.setValue("postalCode1", pc1);
                              methods.setValue("postalCode2", pc2);
  
                              methods.setValue(
                                "locality",
                                addr.city ||
                                addr.town ||
                                addr.village ||
                                addr.municipality ||
                                ""
                              );
                          // Distrito pelo código ISO
                        const isoNumber = parseInt(addr["ISO3166-2-lvl6"].split("-")[1], 10);
  
                          // encontra o distrito
                          // const districtOption = AddressData.find(d => d.code === isoNumber);
                          // setSelect1(districtOption?.district || addr.city || county|| "");    // distrito
                          // console.log(AddressData)
                          // // Concelho
                          // const countyOption = districtOption?.county.find(c => c.countyName === addr.county);
                          // setSelect2(countyOption?.countyName || addr.county || "");
                            const districtOption = AddressData.find(
                              d => String(d.code) === String(isoNumber)
                            );
  
                            setSelect1(
                              districtOption?.district ||
                              addr.state ||
                              addr.city ||
                              ""
                            );
  
                            // Concelho
                            const possibleCountyNames = [
                              addr.county,
                              addr.municipality,
                              addr.city
                            ].filter(Boolean);
  
                            const countyOption = districtOption?.county.find(c =>
                              possibleCountyNames.some(name =>
                                name?.toLowerCase().trim() ===
                                c.countyName?.toLowerCase().trim()
                              )
                            );
  
                            setSelect2(
                              countyOption?.countyName ||
                              possibleCountyNames[0] ||
                              ""
                            );
                          // Freguesia
                          const possibleNames = [
                            addr.city_district,
                            addr.suburb,
                            addr.neighbourhood,
                            addr.village,
                            addr.town
                          ].filter(Boolean);
  
                          const subDivisionOption =
                            countyOption?.freguesias?.find(f =>
                              possibleNames.some(name =>
                                name?.toLowerCase().trim() ===
                                f.freguesiaName?.toLowerCase().trim()
                              )
                            );
  
                          setSelect3(
                            subDivisionOption?.freguesiaName ||
                            possibleNames[0] ||
                            ""
                          );
                          // const subDivisionOption = countyOption?.fregusias.find(f => f.freguesiaName === addr.village || addr.neighbourhood);
                          // setSelect3(subDivisionOption?.freguesiaName || addr.city_district || addr.suburb || addr.town || "" );
                        
                          $(".MuiFormLabel-root").addClass('css-kw1843-MuiFormLabel-root-MuiInputLabel-root');
                        }}
                    />
                      {positionError && (
                        <Typography variant="subtitle2" color="error" py={1}>
                          {t("selectYourPosition")}
                        </Typography>
                      )}
                    </Box>
                  </Paper>
                </Stack>
              </Box>
            </Box>
            <Stack direction={"row"} justifyContent={"space-between"} marginTop={2}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Button
                  onClick={() => {
                    editAddress ? setEditAddress(false) : setOpen(false);
                  }}
                  sx={{
                    background: "#FFEEEE",
                    color: "#FF0000",
                    padding: '8px 22px',
                    borderRadius: '4px',
                    "&:hover": { background: "#FF0000", color: "#FFEEEE" },
                  }}
                >
                  {t("cancel")}
                </Button>
                {editAddress &&
                  entity?.entityAddressId !== address.addressId && (
                    <LoadingButton
                      variant="outlined"
                      color="error"
                      sx={{ ml: 1 ,borderRadius:'4px'}}
                      loading={loading}
                      onClick={onDeleteHandle}
                      type="submit"
                    >
                      {t("delete")}
                    </LoadingButton>
                  )}
              </Box>
              <LoadingButton sx={{
            borderRadius:'4px'
          }} size="large" type="submit" variant="contained">
                {t("toSave")}
              </LoadingButton>
            </Stack>
          </FormProvider>
        </Grid>
      </Grid>
    </>
  );
}
